import { isObject, isString } from 'lodash';
import { captureException } from '@sentry/react';
import { useQuery } from 'react-query';
import { ContentfulConfigId, getContentfulConfig } from 'domains/contentfulConfigs/contentfulConfigs';
import { TypeConfigurationsFields } from 'types/contentful';
import { ContentfulDataError } from 'domains/api/errors';

type TherapistPhoneNumberConfig = TypeConfigurationsFields & {
  configuration: {
    phoneNumber: string;
  };
};

const validateData = (rawData: TypeConfigurationsFields): rawData is TherapistPhoneNumberConfig => {
  const { configuration } = rawData;

  if (!isObject(configuration)) {
    return false;
  }
  if (!isString(configuration.phoneNumber)) {
    return false;
  }

  return true;
};

const getTherapistPhoneNumber = async (): Promise<TherapistPhoneNumberConfig> => {
  const rawData = await getContentfulConfig(ContentfulConfigId.THERAPIST_SUPPORT_PHONE_NUMBER);

  if (!validateData(rawData.fields)) {
    const error = new ContentfulDataError(
      `Bad data for entity ID ${ContentfulConfigId.THERAPIST_SUPPORT_PHONE_NUMBER}`,
    );
    captureException(error);
    throw error;
  }

  return rawData.fields;
};

export const useTherapistSupportNumber = () => {
  return useQuery(['therapist-support-number'], getTherapistPhoneNumber, {
    select: data => data.configuration,
  });
};
